exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-body[data-v-1c2577c0] {\n  padding: 30px 20px;\n  overflow: hidden;\n}\n.panel-body[data-v-1c2577c0]:first-child {\n  background: #2c3e50;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.panel-body[data-v-1c2577c0]:last-child {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.panel-body .progress[data-v-1c2577c0] {\n  margin: 0;\n}\n.panel-body .lead[data-v-1c2577c0] {\n  margin: 0;\n}", ""]);

// exports
